import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  public canActivate(): Observable<boolean> {
    return this.authService.authInitialized.pipe(
      map(_ => {
        if (_) {
          return _;
        }
        this.authService._redirectURL = this.router.parseUrl(
          location.pathname + location.search
        );
        this.authService.navigateToLogin();
        return _;
      }),
      take(1)
    );
  }
}

@Injectable()
export class LazyRouteGuardService implements CanLoad {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  public canLoad(): Observable<boolean> {
    return this.authService.authInitialized.pipe(
      map(_ => {
        if (_) {
          return _;
        }
        this.authService._redirectURL = this.router.parseUrl(
          location.pathname + location.search
        );
        this.authService.navigateToLogin();
        return _;
      }),
      take(1)
    );
  }
}

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private authService: AuthenticationService) {}

  public canActivate(): boolean {
    if (!this.authService.isAuthenticated) {
      return true;
    }
    this.authService.navigateToHomePage();

    return false;
  }
}
